'use client'
import dynamic from 'next/dynamic'

import { RaButton } from '@components/core/index.core'
import { useUi } from '@contexts/ui.context'
import { AcfForm } from '@typings'
import { GA4Events } from '@/utilities/ga4-helpers/GA4Events.helpers'
import { useSettings } from '@/contexts/settings.context'

const RaFormWrapper = dynamic(() =>
  import('@components/form-elements/RaFormWrapper/RaFormWrapper').then(
    ({ RaFormWrapper }) => RaFormWrapper
  )
)

const RaTravelplanForm = dynamic(() =>
  import('@components/features/RaTravelplanForm/RaTravelplanForm').then(
    ({ RaTravelplanForm }) => RaTravelplanForm
  )
)

interface RaFormDialogButtonProps {
  form: AcfForm
  label: string
  modalTitle?: string
  fullscreen?: boolean
  forwardProps?: any
  isTravelplan?: boolean
}

export const RaFormDialogButton = ({
  form,
  label,
  modalTitle,
  fullscreen = true,
  forwardProps,
  isTravelplan = false,
}: RaFormDialogButtonProps) => {
  const { GTM_ID, destination } = useSettings()
  const analytics = new GA4Events({ mode: 'client', gtmId: GTM_ID })

  const ui = useUi()
  const openFormDialog = () => {
    if (!ui) {
      console.warn('Modal context is not defined')
    }

    if (isTravelplan) {
      ui.showModal({
        content: (
          <RaTravelplanForm
            form={form}
            title={forwardProps.title}
            image={forwardProps.image}
          />
        ),
        fullscreen,
        bgColor: 'var(--color-bg-light)',
        isTravelplan: true,
        customCloseButton: forwardProps.close,
      })
    } else {
      ui.showModal({
        title: modalTitle ? modalTitle : label,
        content: <RaFormWrapper {...form} />,
        fullscreen,
      })
      analytics.openEnquiryModal({
        title: modalTitle || label,
        country: destination,
      })
    }
  }
  return (
    <RaButton
      type="button"
      label={label}
      onClick={openFormDialog}
    />
  )
}
